import { Controller } from "@hotwired/stimulus";

// Petit helper pour les questions yes_no du runner audit : montre/cache
// le bloc "followup" quand l'auditeur sélectionne « Non ».
export default class extends Controller {
  static targets = ["followup"];
  static values = { action: String, docTarget: String };

  onChange(event) {
    if (!this.hasFollowupTarget) return;
    this.followupTarget.hidden = event.target.value !== "non";
  }
}
